import React, { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import SubstateSelect from './SubstateSelect';
import InfoButton from '../selectComponents/InfoButton';

export default function OtherAreaSelect(props) {
    const { userParams, setUserParams, setShowGoButton } = props;
    const [otherType, setOtherType] = useState();
	const [postals, setPostals] = useState("");

    const handleTypeChange = (event) => {
        const newType = event.target.value;
        setOtherType(newType);
    };

	const handleStateChange = (event) => {
		const newPostals = event.target.value.replace(" ","");
		setPostals(newPostals);
        setShowGoButton(true);
	};

    return (
        <Stack direction="row" spacing={2} sx={{ pt: 0 }}>
            <ToggleButtonGroup
                value={otherType}
                exclusive
                orientation="vertical"
                onChange={handleTypeChange}
            >
                <ToggleButton size="small" value="county">
                    County
                </ToggleButton>
                <ToggleButton size="small" value="climdiv">
                    Climate Division
                </ToggleButton>
                <ToggleButton size="small" value="cwa">
                    NWS County Warning Area
                </ToggleButton>
                <ToggleButton size="small" value="basin">
                    Drainage Basin
                </ToggleButton>
            </ToggleButtonGroup>
            {otherType &&
                <Stack direction="column" spacing={2}>
                    <Box sx={{ mt: 0 }}>
                        <TextField
                            label="State"
                            value={postals}
                            autoFocus
                            sx={{ width: "12em", mt: 1 }}
                            onChange={handleStateChange}
                            InputProps={{endAdornment:(<InfoButton infoFor="substate" edge={false} />)}}
                            inputProps={{ spellCheck: false }}
                        />
                    </Box>
                    <SubstateSelect 
                        userParams={userParams}
                        setUserParams={setUserParams} 
                        postals={postals}
                        otherType={otherType}
                    />
                </Stack>
            }
        </Stack>
	)
}